<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import DonationPage from '@/pages/DonationPage.vue'

import LoadingSpinner from '@/components/LoadingSpinner.vue'
import PageLayout from '@/components/templates/PageLayout.vue'

const route = useRoute()
const id = computed(() => route.params.id as string | undefined)
</script>

<template>
  <PageLayout>
    <Suspense>
      <DonationPage :id="id" :key="id" />
      <template #fallback><LoadingSpinner /></template>
    </Suspense>
  </PageLayout>
</template>
